import script from "./WorkspaceIcon.vue?vue&type=script&lang=js"
export * from "./WorkspaceIcon.vue?vue&type=script&lang=js"

import "./WorkspaceIcon.vue?vue&type=style&index=0&id=1dcefcbe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1dcefcbe"]])

export default __exports__